require('./bootstrap');

import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
import util from './util';
import Clipboard from './plugins/clipboard';
import messages from './funcs/message.json';

const app = createApp({});
const files = require.context('./components', true, /\.vue$/i);
files.keys().forEach((key) => {
    app.component(key.split('/').pop().split('.')[0], files(key).default);
});

app.mixin(util);
app.use(FloatingVue);
app.use(Clipboard);
app.use(createI18n({ locale: 'ja', legacy: false, messages }));
app.mount('#app');
